export const UI_FLAG_HOT_TOURS = 'LOAD_DATA_FOR_HOT_TOURS';
